import store from '../../redux/app/store';
import { showSnackBar, InitialStateProps } from '../../redux/features/SnackBar/snackBarSlice';

export const displaySnackBar = (snackBarState: InitialStateProps) => {
  store.dispatch(showSnackBar(snackBarState));
};
